__webpack_require__.p = "/MyWavePortal-Frontend/";